import { extractErrorMessage } from '../../../utilities';
import logger from '../../../utils/logging';
import MidwayClient from './midway_client';

let asinMetricsClient;

export function getAsinMetricsClient() {
  if (!asinMetricsClient) {
    asinMetricsClient = new AsinMetricsClient();
  }
  return asinMetricsClient
}

export class AsinMetricsClient extends MidwayClient{
  constructor(props) {
    super();
    this.props = props || {};
  }

  clientLoaded = (client) => {
    this.asinMetricsClient = client;

    if (this.props.hasOwnProperty('onReady')) {
      this.props.onReady();
    }
  };

  post = (endpoint, payload, callback, errorCallback) => {
    this.asinMetricsClient.post(endpoint, payload)
        .then((response) => callback(response))
        .catch((error) => {
          logger.error(extractErrorMessage(error), error);
          if (errorCallback) {
            errorCallback(error);
          }
        });
  }

  postWithAsinTypeCallback = (endpoint, payload, type, callback, errorCallback) => {
    return this.asinMetricsClient.post(endpoint, payload)
        .then((response) => callback(response, type))
        .catch((error) => {
          logger.error(extractErrorMessage(error), error);
          if (errorCallback) {
            errorCallback(error);
          }
        });
  }

  getGlMetrics = async (callback, errorCallback, payload) => {
    logger.info('Attempting to get glMetrics', payload);
    try {
      const response = await this.asinMetricsClient.post('glMetric', payload);
      await callback(response);
    } catch (error) {
      logger.error(extractErrorMessage(error), error);
      if (errorCallback) {
        errorCallback(error);
      }
    }
  };

  getAsinMetrics = (callback, errorCallback, payload) => {
    logger.info('Attempting to get asinMetrics', payload);
    this.post('asinMetric', payload, callback, errorCallback);
  }

  getHistogram = (callback, errorCallback, payload) => {
    logger.info('Attempting to get histogram data', payload);
    const type = payload.metric;
    this.postWithAsinTypeCallback('histogram', payload, type, callback, errorCallback);
  };

  getHistogramAsin = (callback, errorCallback, payload) => {
    logger.info('Attempting to get histogram asin info', payload);
    const type = payload.metric;
    this.postWithAsinTypeCallback('histogramAsin', payload, type, callback, errorCallback);
  };

  getStabilizationPeriod = (callback, errorCallback, payload) => {
    logger.info('Attempting to get stabilization period', payload);
    this.post('stabilizationPeriod', payload, callback, errorCallback);
  };
}



// WEBPACK FOOTER //
// ./src/components/reports/asin_metrics/asin_metrics_client.jsx